import type { StatusOption, VerifySearchValues } from "../types.ts";
import type { ExcelHeaderCellsName } from "@/features/operations/verifications/types.ts";
import { VerificationStageStatus } from "@/features/operations/verifications/types.ts";

// ============================================
// Verify Search Defaults
// ============================================

export const verifySearchValues: VerifySearchValues = {
  verificationStageStatus: "",
  projectIds: [],
  projectAttributeId: "",
  projectClassificationId: "",
  toTime: "",
  fromTime: "",
  stageName: "",
  driverId: "",
  smsSendingDateTimeFrom: "",
  smsSendingDateTimeTo: "",
  searchKey: "",
  isPrinted: "",
  isFirstStageVerified: "",
};

// ============================================
// Status Options
// ============================================

export const statusOptions: StatusOption[] = [
  {
    value: VerificationStageStatus.Assigned,
    name: "تم الاسناد",
  },
  {
    value: VerificationStageStatus.WaitingVerification,
    name: "في انتظار التحقق",
  },
  {
    value: VerificationStageStatus.Verified,
    name: "تم التحقق",
  },
  {
    value: VerificationStageStatus.Rejected,
    name: "مرفوض",
  },
  {
    value: VerificationStageStatus.WaitingSendingTime,
    name: "في انتظار تاريخ التنفيذ",
  },
  {
    value: VerificationStageStatus.ProcessingFiles,
    name: "جاري معالجة الملفات",
  },
];

// ============================================
// Excel Header Mappings
// ============================================

export const verifyExcelHeaders: ExcelHeaderCellsName = {
  "اسم المشروع": "projectName",
  "اسم السمة": "attributeName",
  "رقم الطلب": "orderId",
  "حالة التحقق": "verificationStageStatus",
};
